(function () {
    'use strict';

    angular
        .module('appback')
        .directive('horaTexto', horaTexto);

    /**
     * Para un <input type="time" ng-model> (campo backend\components\fields\Hora):
     * AngularJS convierte el modelo de input[type=time] en un Date (y exige un
     * Date para pintarlo), que el CMS acaba guardando como fecha ISO del
     * 1970-01-01 en UTC. Se quitan sus parsers/formatters para que el modelo
     * sea el texto "HH:MM" tal cual lo da el navegador.
     *
     * Los navegadores no pintan flechas en input[type=time]: los botones
     * [data-hora-paso] de al lado suben o bajan la hora un "step" del input
     * con su stepUp()/stepDown() nativos.
     */
    function horaTexto() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var input = element[0];

                ngModel.$parsers.length = 0;
                ngModel.$formatters.length = 0;

                var flechas = angular.element(element.parent()[0].querySelectorAll('[data-hora-paso]'));

                function alPulsar(event) {
                    var paso = parseInt(event.currentTarget.getAttribute('data-hora-paso'), 10);
                    try {
                        if (paso > 0) {
                            input.stepUp();
                        } else {
                            input.stepDown();
                        }
                    } catch (e) {
                        return;
                    }

                    scope.$apply(function () {
                        ngModel.$setViewValue(input.value);
                    });
                }

                flechas.on('click', alPulsar);
                scope.$on('$destroy', function () {
                    flechas.off('click', alPulsar);
                });
            }
        };
    }
})();
